import { useEffect, useState } from "react";

export default function useSmile({ smileCode }: { smileCode: string }) {
  const [smileTree, setSmileTree] = useState<any>();
  const [error, setError] = useState<any>();

  useEffect(() => {
    import("smiles-drawer").then((mod) => {
      mod.default.parse(
        smileCode,
        (tree: any) => setSmileTree(tree),
        (err: any) => setError(err),
      );
    });
  }, [smileCode]);

  return { smileTree, error };
}
